import axios from 'axios';

export const SUPPORT_API_BASE = 'https://support.mobiapi.net';

export type CreateTicketPayload = {
  title: string;
  description: string;
  status?: number;
  priority?: number;
  product_code?: number;
  vendor_ref?: number;
  contact_ref?: number;
  assigned_to?: string;
  assigned_to_name?: string;
  customer_name?: string;
  customer_email?: string;
  attachments?: any[];
  due_date?: string;
  first_responded_at?: string;
  closed_at?: string;
};

export async function createTicket(payload: CreateTicketPayload) {
  const res = await axios.post(`${SUPPORT_API_BASE}/api/tickets`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data;
}

export async function getTicket(ref: string) {
  const res = await axios.get(`${SUPPORT_API_BASE}/api/tickets/${ref}`);
  return res.data;
}

export async function listTickets(params?: Record<string, any>) {
  const res = await axios.get(`${SUPPORT_API_BASE}/api/tickets`, { params });
  return res.data;
}

export type CreateMessagePayload = {
  ticket_ref: string;
  content: string;
  sender_id: string;
  sender_name: string;
  sender_type: 'support' | 'customer' | string;
  is_internal?: boolean;
  attachments?: any[];
};

export async function listTicketMessages(ticketRef?: string) {
  const res = await axios.get(`${SUPPORT_API_BASE}/api/ticket-messages`, {
    params: ticketRef ? { ticket_ref: ticketRef } : undefined,
  });
  return res.data;
}

export async function createTicketMessage(payload: CreateMessagePayload) {
  const res = await axios.post(`${SUPPORT_API_BASE}/api/ticket-messages`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data;
}

export async function closeTicket(ref: string) {
  const res = await axios.post(`${SUPPORT_API_BASE}/api/tickets/${ref}/close`);
  return res.data;
}

export async function assignTicket(ref: string, body: any) {
  const res = await axios.post(`${SUPPORT_API_BASE}/api/tickets/${ref}/assign`, body);
  return res.data;
}

export async function escalateTicket(ref: string, body: any) {
  const res = await axios.post(`${SUPPORT_API_BASE}/api/tickets/${ref}/escalate`, body);
  return res.data;
}

export async function updateTicket(ref: string, body: any) {
  const res = await axios.patch(`${SUPPORT_API_BASE}/api/tickets/${ref}`, body);
  return res.data;
}
